import  Banner from "../components/Banner"
import  Industries from "../components/Industries"
import  Features from "../components/Features"
import Security from "../components/securityFeatures";
import TryFreePage from "../components/shared/TryFree";
import PricingSection from "../components/Pricing";
import FAQAccordion from "../components/FAQSection";
import ContactUs from "../components/ContactUs";
import React from "react";
import Dashbaord from "../components/AnalysisFeature";



const Home = ()=>{
    return(
        <>
            <Banner/>
            <TryFreePage/>
            <Features/>
            <PricingSection/>
            <Industries/>
            <Dashbaord/>
            <Security/>
            <FAQAccordion/>
            <ContactUs/>
        </>
    )
}
export  default  Home